import { debounceEvent, detectMobile, detectMobileUntilTablet } from '../../../js/utils';

export default class CmsGridComponent {
  constructor(cmsGridComponentContainerAnimated) {
    this.cmsGridComponentContainerAnimated = cmsGridComponentContainerAnimated;

    if (!this.cmsGridComponentContainerAnimated) {
      return;
    }

    this.cmsGridRowElements = document.querySelectorAll('.swa-grid-component--animated .swa-grid-component__row');
    this.cmsGridHeadlines = document.querySelectorAll('.swa-grid-component--animated .swa-grid-component__headline');
    this.cmsGridSubHeadlines = document.querySelectorAll('.swa-grid-component--animated .swa-grid-component__subHeadline');
  }

  scrollObserver() {
    let rowObserver;
    let headlineObserver;
    let subHeadlineObserver;
    let options;
    let rootMargin;

    if (detectMobileUntilTablet()) {
      rootMargin = '0px 0px -230px 0px';
    }
    else {
      rootMargin = '0% 0% -40% 0%';
    }

    options = {
      root: null,
      rootMargin: rootMargin,
    };

    // Since headlines and rows are siblings, two observers were needed
    // observer for grid component icon with text row
    rowObserver = new IntersectionObserver(this.rowHandleIntersect, options);
    this.rowObserver = rowObserver;
    this.cmsGridRowElements.forEach((row) => {
      this.rowObserver.observe(row);
    });

    // observer for grid component icon with text headline
    headlineObserver = new IntersectionObserver(this.headlineHandleIntersect, options);
    this.headlineObserver = headlineObserver;
    this.cmsGridHeadlines.forEach((headline) => {
      this.headlineObserver.observe(headline);
    });

    // observer for grid component subHeadline
    subHeadlineObserver = new IntersectionObserver(this.headlineHandleIntersect, options);
    this.subHeadlineObserver = subHeadlineObserver;
    this.cmsGridSubHeadlines.forEach((subHeadline) => {
      this.subHeadlineObserver.observe(subHeadline);
    });
  }

  rowHandleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delayIconWithTextAnimation = 200;

        let iconWithTextElements = entry.target.querySelectorAll('.swa-grid-component__element .swa-cms-icon-with-text');

        iconWithTextElements.forEach((iconWithTextElement, index) => {
          setTimeout(() => {
            //the animation will show the icons with text (from current row) one by one with a delay
            iconWithTextElement.style.animation = `fadeInCmsIconsWithText .8s ease-in-out 0s 1 forwards `;
          }, index * delayIconWithTextAnimation);
        });

        observer.unobserve(entry.target);
      }
    });
  }

  headlineHandleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let iconWithTextHeadline = entry.target;
        iconWithTextHeadline.style.animation = `fadeInCmsIconsWithText .8s ease-in-out 0s 1 forwards `;

        observer.unobserve(iconWithTextHeadline);
      }
    });
  }

  subHeadlineHandleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let subHeadline = entry.target;
        subHeadline.style.animation = `fadeInCmsIconsWithText .8s ease-in-out 0s 1 forwards `;

        observer.unobserve(subHeadline);
      }
    });
  }

  addServicesGridClasses () {
    const servicesContainers = this.cmsGridComponentContainerAnimated.querySelectorAll('.js-service-container-component');
    // if there are grid service elements => dynamically add the needed classes
    if (servicesContainers && servicesContainers.length) {
      const gridComponent = servicesContainers[0].closest('.swa-grid-component');
      gridComponent && gridComponent.classList.add('swa-grid-component--services');

      servicesContainers.forEach(service => {
        const gridElement = service.closest('.swa-grid-component__element');
        gridElement && gridElement.classList.add('swa-grid-component__element--service');
      });
    }
  }

  addWindowResizeListener() {
    window.addEventListener(
      'resize',
      debounceEvent(() => {
        let currentIsMobile = detectMobile();
        if ((this.isMobile !== currentIsMobile) && this.isMobile) {
          this.rowObserver.unobserve(this.cmsGridComponentContainerAnimated);
          this.scrollObserver();
          this.isMobile = !this.isMobile;
        } else if ((this.isMobile !== currentIsMobile) && !this.isMobile) {
          this.rowObserver.unobserve(this.cmsGridComponentContainerAnimated);
          this.scrollObserver();
          this.isMobile = !this.isMobile;
        }
      }, 250)
    );
  }

  init() {
    this.isMobile = detectMobile();
    this.scrollObserver();
    this.addWindowResizeListener();
    this.addServicesGridClasses();
  }
}
